import { LabelProps, XAxisProps, YAxisProps } from "recharts";

/**
 * Recharts writes these as SVG presentation attributes, where CSS var() does
 * not resolve — but currentColor does, so axis chrome inherits the surrounding
 * text colour and follows the mode without threading a hook through 11 charts.
 */
const TICK_COLOR = "currentColor";
const TICK_MARGIN = 8;
const TICK_SIZE = { x: 0, y: 24 };
const TICK_FONT_SIZE = 13;

export const TICK_YEARS = [1990, 2000, 2025, 2050, 2075, 2100];

export const Y_AXIS_LABEL_TOP_OFFSET = 32;
/** Short metric label props for chart yAxis (MVAR, PL, FP, TIP...) */
export const yAxisLabelProps = (value: string): LabelProps => ({
  value,
  position: "top",
  offset: 24,
  fill: "currentColor",
  fillOpacity: 0.55,
  fontSize: 12,
  dx: -8,
});

export const yAxisBaseProps: YAxisProps = {
  orientation: "right",
  tick: { fill: TICK_COLOR, fontSize: TICK_FONT_SIZE, dy: -12, dx: -32 },
  width: 44,
  axisLine: { stroke: "transparent" },
  tickSize: TICK_SIZE.y,
  tickMargin: TICK_MARGIN,
  tickLine: { stroke: TICK_COLOR },
};

export const xAxisBaseProps: XAxisProps = {
  tick: { fill: TICK_COLOR, fontSize: TICK_FONT_SIZE },
  axisLine: { stroke: "transparent" },
  height: 24,
  tickSize: TICK_SIZE.x,
  tickMargin: TICK_MARGIN,
  padding: { left: 8, right: 8 },
};
